<template>
    <v-container>

        <v-row>
            <!-- LEFT SIDE -->
            <v-col cols="12" md="6">
                <v-row>
                    <!-- ALERTS -->
                    <v-col cols="12">
                        <new-messages/>
                        <no-phone-set/>
                    </v-col>
                    <!-- WELCOME -->
                    <v-col cols="12">
                        <div class="title-text">
                            {{ welcome }}
                        </div>
                        <div class="subtitle-text my-2">
                            {{ $t('company.welcome_subtext') }}
                        </div>
                        <v-divider class="primary" style="border-width: 1px"/>
                    </v-col>
                    <!-- TABLE STATISTICS INFO -->
                    <v-col cols="12">
                        <table-basic-info full-width :items="itemsInfo"/>
<!--                        <go-to :name="$t('to.statistics')" :to="{name: 'company.statistics'}"/>-->
                    </v-col>
                    <!-- CREATE ROUTINES -->
<!--                    <v-col cols="12">-->
<!--                        <create-routine-card/>-->
<!--                        <go-to :name="$t('to.routines')" :to="{name: 'company.routines'}"/>-->
<!--                    </v-col>-->
                    <!-- STATISTICS -->
<!--                    <v-col cols="12">-->
<!--                        <statistics-card/>-->
<!--                        <go-to :name="$t('to.see_statistics')" :to="{name: 'company.statistics'}"/>-->
<!--                    </v-col>-->
                </v-row>
            </v-col>
            <!-- RIGHT SIDE -->
            <v-col cols="12" md="6">
                <!-- CALENDAR ROUTINES -->
<!--                <v-col cols="12" class="text-center">-->
<!--                    <mini-calendar-advance/>-->
<!--                </v-col>-->
                <v-col cols="12">
                    <subscription-status/>
                    <current-subscription/>
                    <go-to :name="$t('to.plans')" :to="{name: 'company.profile.edit', params: {mode: 'SelectPlan'}}"/>
                </v-col>
            </v-col>
        </v-row>

    </v-container>
</template>

<script>

import {mapActions, mapState} from "vuex";
import SubscriptionStatus from "@/components/student/SubscriptionStatus";
import NewMessages from "@/components/elements/alerts/NewMessages";
import NoPhoneSet from "@/components/elements/alerts/NoPhoneSet";
import TableBasicInfo from "@/components/elements/table/TableBasicInfo";
import GoTo from "@/components/elements/buttons/goTo";
import CreateRoutineCard from "@/components/elements/cards/CreateRoutineCard";
import MiniCalendarAdvance from "@/components/elements/cards/MiniCalendarAdvance";
import CurrentSubscription from "@/components/elements/cards/CurrentSubscription";
import StatisticsCard from "@/components/elements/cards/StatisticsCard";
import {db} from "@/utils/Firebase";

export default {
    components: {
        StatisticsCard,
        CurrentSubscription,
        MiniCalendarAdvance,
        CreateRoutineCard,
        GoTo,
        TableBasicInfo,
        NoPhoneSet,
        NewMessages,
        SubscriptionStatus,
    },
    data() {
        return {
            activeCoaches: 0,
            activeStudents: 0,
        }
    },
    computed: {
        welcome(vm = this) {
            let name = vm.account?.name || ''
            return vm.$t('common.hello', {name})
        },
        itemsInfo(vm = this) {
            return [
                {name: vm.$t('admin.active_coaches'), value: vm.activeCoaches},
                {name: vm.$t('admin.active_students'), value: vm.activeStudents},
            ]
        }
    },
    async mounted() {
        const vm = this
        await vm.loadCoaches()
    },
    methods: {
        async loadCoaches() {
            const vm = this
            let coachesRef = await db.collection('users')
                .where('coachSubscription.companyId', '==', vm.currentUser.uid).get()

            vm.activeCoaches = coachesRef.docs.length
            let activeStudents = 0

            coachesRef.docs.forEach(coach => {
                activeStudents += coach.data()?.activeStudents || 0
            })

            vm.activeStudents = activeStudents
        }
    },
}
</script>

<style scoped>

</style>